
import LICENSES from "./licenses";
import {  faChild, faChartLine, faPhoneAlt, faInfoCircle, faColumns, faSitemap, faDatabase, faBrain, faUserNinja, faUserGraduate, faSlidersH, faTabletAlt, faBabyCarriage, faRunning, faSpaceShuttle, faMeteor, faFilter, faUpload, faLayerGroup, faExpand, faMouse, faClipboardList,faWifi, faRandom, faBiking, faNetworkWired, faHourglassHalf, faExchangeAlt, faRobot, faCrosshairs, faTable, faPuzzlePiece, faPaintRoller } from '@fortawesome/free-solid-svg-icons'

var AMCConstants = {
	VERSION: 0.01,
	SUBVERSION: "1619223224007 (4/23/2021, 5:13:44 PM)",
	production: false,
	staging: false,
	platform: window.location.hostname.indexOf("automatic.ai") !== -1 ? "production" : window.location.hostname.indexOf("fab.ai") !== -1 ? "staging" : "dev",
	DOMAIN_NAME: "automatic.ai",
	SEARCH_SPECIAL_FOCUS_CHAR: "_",
	ROCKSTAR_VERSION: "0.01",
	NINJA_VERSION: "0.01",
	DEFAULT_SPEED: 1,
	SPEEDS: [
		{ name: "AWS Lambda 1Gb", desc: "Gets the job done and probably the best price per job if you are willing to wait.", id: 1 },
		{ name: "AWS Lambda 3Gb", desc: "Faster and perhaps more expensive per job but it gets it done quicker.", plans: ["pro", "enterprise", "premium"], id: 3 },
		// { name: "10", desc: "Infinity grade compute. The most kickass GPU we have access to. Perhaps the most expensive per job but it gets it done ASAP.", plans: ["pro", "enterprise", "premium"], id: 10 },
	],
	LOGO: "/images/zooapplogo365.png",  // 276, 250 , 251, 300, 365
	DARKTHEME_LOGO: "/images/logowhite.png",  // 276, 250 , 251, 300, 365
	ROCK_DATA_BUCKET_PRODUCTION: "https://data.automatic.ai", 
	ROCK_DATA_BUCKET_STAGING: "https://data.fab.ai",
	ROCKSTAR_DEMO_URI: "core/service/example-housing-price-predictor",
	RESIZABLE_PANEL_CLASSNAME: "ResizablePanel",
	COMMON_SPEC: [
		{ name: "Name", field: "name", kind: "string", minlen: 1, maxlen: 64, hint: "Convenient name for this component in your App", required: false, "protected": true },
		{ name: "Owner", field: "owner", kind: "string", readonly: true, hint: "The author or current primary contact" },
		{ name: "Group", field: "group", kind: "string", readonly: true, hint: "Who owns this, typically the author or author's employer" },
		{ name: "Permissions", field: "permissions", kind: "menu", choices:["public", "private"], "default": "public", hint: "Whether people can use your component and view its implementation, or whether it is completely private", "protected": true, required: true },
//		{ name: "Published", field: "published", kind: "boolean", "default": false, hint: "Whether this is visible in the zoo", "protected": true },
		{ name: "License", field: "license", kind: "menu", choices: LICENSES.map(x => x[0]), "default": "MIT (mit)", "protected": true, hint: "The opensource license that applies to this when public" },
		{ name: "Thumbnail", field: "thumb", kind: "cloudinary", folder: "things", size: "thumb", hint: "Image used when this is displayed in search results", "protected": true },
		{ name: "Description", field: "description", kind: "text", minlen: 3, maxlen: 1024, hint: "Abstract description of what this does and how it does it", required: false, "protected": true },
		{ name: "Attribution", field: "attribution", kind: "string", minlen: 3, maxlen: 256, hint: "Link, email, handle or name of original source, if any", required: false },
		{ name: "Version", field: "version", kind: "integer", hint: "The integer version number is managed by automatic and increased automatically when this is forked", required: true, protected: true, "default": 0, readonly: true },
//		{ name: "Pricing", field: "pricing", kind: "string", minlen: 0, maxlen: 16, hint: "Some authors charge a small per-use or one-time fee (not implemented)", required: false, protected: true },
//		{ name: "Published", field: "published", kind: "boolean", hint: "(unimplemented) The search engine and leaderboards can feature this, if public", "default": true, required: false },
		{ name: "Tags", field: "tags", kind: "string", minlen: 3, maxlen: 128, hint: "Tags that describe the purpose or implementation", required: false, "protected": true },
	],
	COMMON_SPECS: {
		"service":  [
//			{ name: "Usecase", field: "usecase", kind: "menu", choices: USECASES, hint: "Most common use case when this might be most useful", required: false, "protected": true, "default": "prediction" },
//			{ name: "Language", field: "language", kind: "menu", choices: ["js", "py"], hint: "Only one language can be used by a service", required: true, "protected": true, "default": "py" },
			{ name: "Framework", field: "framework", kind: "menu", choices: ["sklearn", "tensorflow", "pytorch"], hint: "Only one machine learning framework can be used by a service", required: true, "protected": true, "default": "pytorch", readonly: true },
			{ name: "Stacks", field: "stacks", kind: "checkboxes", choices: ["numpy", "pillow", "pandas", "matplotlib", "scipy", "sklearn"], hint: "Support packages are automatically calculated from the dependencies specified by this service's components", required: false, "protected": true, readonly: true },
			{ name: "Speed", field: "speed", kind: "integer", hint: "The compute used during the last train/test/deploy", required: false, "protected": true, readonly: true },
			{ name: "Compute", field: "compute", kind: "integer", hint: "The compute requested for the next train/test/deploy. If blank then the account's default is used at the time of the respective operation", required: false, "protected": true, readonly: true },
		],
	},
	PLAN_ICONS: {
		guest: faBabyCarriage,
		member: faRunning,
		premium: faBiking,
	 	pro: faSpaceShuttle,
	 	business: faMeteor,
	},
	FRAMEWORK_DEPENDENCIES: {
		sklearn: ["scipy", "numpy"],
		pytorch: ["numpy"],
		tensorflow: ["scipy", "numpy"]
	},
	// ATMService.reportPlot
	ATMSERVICE_DEPENDENCIES: ["pillow", "matplotlib"],
	FREE_TIER_PLATFORM: "free tier",
	TRAINING_PLATFORM_OPTIONS: [ "free tier", "warp 1", "warp 2", "warp 3" ],
	TOP_SPEED_POSSIBLE: 200,
	DEFAULT_INSPECTOR_WIDTH_PERCENTAGE: 50,
	NODE_OWNER_ICON_BG_COLORS: ["#808", "#0af", "#0a0", "#b00"],
	DEFAULT_WTF_URI: "core/wtf/basics",
	DEFAULT_FREAKOUT_URI: "core/freakout/basics",
	DEFAULT_HELPMECHOOSE_URI: "core/helpmechoose/basics",
	DEFAULT_ROCKPILE_URI: "core/rockpile/basics",
	DEFAULT_THEME_URI: "core/theme/robot",
	DEFAULT_THEMES_URI: "core/themes/basics",
	PRICING_URI: "/-/pricing",
	ACCOUNT_URI: "account",
	DASHBOARD_URI: "dashboard",
	LEADERBOARDS_URI: "/leaderboards",
	DEMOS_URI: "/demos",
	GOT_DATA_URI: "/gotdata",
	GOT_MODEL_URI: "/gotmodel",
	TRACKINGS_LOADED: "trackingsloaded",

	LEADERBOARDS_TRACKING_URI: "leaderboards-tracking",
	DEMOS_TRACKING_URI: "demos-tracking",
	ZOOTOP_TRACKING_URI: "zootop-tracking",
	GOT_DATA_TRACKING_URI: "gotdata-tracking",
	GOT_MODEL_TRACKING_URI: "gotmodel-tracking",
	GOT_ALGORITHM_TRACKING_URI: "gotalgorithm-tracking",
	GOT_DATA_SAVE_TRACKING_URI: "addnewdata-tracking",
	GOT_MODEL_SAVE_TRACKING_URI: "addnewmodel-tracking",
	BOSTON_CLASSIC_TRACKING_URI: "bostonclassic-tracking",
	EXISTING_SERVICES_TRACKING_URI: "existingservices-tracking",
	NINJA_TRACKING_URI: "ninja-tracking",

	BOSTON_CLASSIC_URL: "/zoo/core/service/example-housing-price-predictor",

  MODAL_DIALOG_ZINDEX: 10,


	COMPONENTS_WITHOUT_SPEC_OR_IMP: [
		"pipeline"
	],

  ZOO_SIDEBAR_STATE: "zoo sidebar state",



	RESERVED_WORDS: [ "zoo", "rockstar", "search", "upload", "dashboard", "leaderboard", "likes", "following", "account", "trending", "tag", "gotdata", "gotalgorithm" ],





	ALGORITHMS: [ "CNN", "RNN", "Neural Network", "RL", "LSTM", "GAN", "BERT", "AutoML" ],
	TECHNOLOGIES: [ "extractor", "filter", "transformer", "splitter", "model" ],




	DATAKIND_SUPERVISED: 	"supervised",

}


export var KINDS = {
		service: { icon: faTabletAlt },
		datasource: { icon: faDatabase },
		dataset: { icon: faDatabase },
	 	filter: { icon: faFilter },
	 	extractor: { icon: faUpload },
	 	transformer: { icon: faRandom },
	 	augmentor: { icon: faLayerGroup },
	 	algorithm: { icon: faSlidersH },
	 	trainer: { icon: faSlidersH },
	 	tester: { icon: faSlidersH },
	 	pipeline: { icon: faNetworkWired },
	 	network: { icon: faNetworkWired },
//	 	trainer: { icon: faPuzzlePiece },
	 	model: { icon: faBrain },
	 	modelsource: { icon: faBrain },
	 	modelset: { icon: faBrain },
	 	manager: { icon: faClipboardList },
	 	//rules: { icon: faClipboardList },
	 	api: { icon: faPhoneAlt },
	 	ui: { icon: faMouse },
	 	deployer: { icon: faWifi },
//	 	recommender: { icon: faPuzzlePiece },
//	 	zooRecommender: { icon: faPuzzlePiece },
//	 	widget: { icon: faPuzzlePiece },
	 	dashboard: { icon: faColumns },
	 	wtf: { icon: faUserGraduate },
	 	ninja: { icon: faUserNinja },
	 	theme: { icon: faPaintRoller },
	 	helpmechoose: { icon: faInfoCircle },
	 	freakout: { icon: faChild },
	 	architecture: { icon: faSitemap },
	 	placeholder: { icon: faExpand },
	 	optimizer: { icon: faHourglassHalf },
	 	splitter: { icon: faExchangeAlt },
	 	automl: { icon: faRobot },
	 	predictor: { icon: faCrosshairs },
	 	viz: { icon: faChartLine },
	 	stats: { icon: faTable },
	 	rockpile: { icon: faPuzzlePiece },
	 	themes: { icon: faPaintRoller },
//	 	trigger: { icon: faPuzzlePiece }, // data trigger, model trigger, monitor trigger...
}

export var PLANS = {
		guest: { icon: faBabyCarriage },
		member: { icon: faRunning },
		premium: { icon: faBiking },
	 	pro: { icon: faSpaceShuttle },
	 	business: { icon: faMeteor },
}

export		const ROCK_IO_PORT_SHAPES = {
			pandas: "Bump", tensor: "Semi"
		}
export		const ROCK_IO_PORT_GENERICS = {
			datasource: { inputs: ["glue: glue"], outputs: ["X: pandas", "y: pandas"]  },
			filter: { inputs: ["X: pandas", "y: pandas"], outputs: ["X: pandas", "y: pandas"] },
			augmentor: { inputs: ["X: pandas", "y: pandas"], outputs: ["X: pandas", "y: pandas"] },
			transformer: { inputs: ["X: pandas", "y: pandas"], outputs: ["X: pandas", "y: pandas"] },
			viz: { inputs: ["X: pandas", "y: pandas"], outputs: ["X: pandas", "y: pandas"] },
			stats: { inputs: ["X: pandas", "y: pandas"], outputs: ["X: pandas", "y: pandas"] },
			algorithm: { inputs: ["X: pandas", "y: pandas"] },
			automl: { inputs: ["X: pandas", "y: pandas"], outputs: [ "output: code" ] },
			splitter: { inputs: ["X: pandas"], outputs: ["X: pandas", "y: pandas"] },
			service: { },
			model: { },
			modelsource: { },
			predictor: { inputs: ["X: pandas"], outputs: [ "output: dict" ] },
			simplifier: { inputs: ["glue: glue"] },
			optimizer: { inputs: ["glue: glue"] },
			pipeline: { outputs: ["glue: glue"] },
		};
//export		const ALGORITHM_ROCK_PILE_GENERICS = {
//		};
//export		const GENERIC_ROCKS = {
//		};

/*
export		const ROCK_PILE_INDEX = [
//			{ label: "generic", kinds: ["generic"] },
			{ label: "Datasets", kinds: ["dataset"] },
			//{ label: "Datasets", kinds: ["dataset", "datasource"] },
			{ label: "Data", kinds: ["datasource"] },
			{ label: "ETL", kinds: ["filter", "augmentor", "transformer"] },
			{ label: "Modelsets", kinds: ["modelset"] },
			{ label: "Models", kinds: ["modelsource"] },
//			{ label: "", kinds: ["algorithm", "automl", "predictor"] },
			{ label: "Trainers", kinds: ["trainer", "automl"] },
			{ label: "Testers", kinds: ["tester"] },
			{ label: "Predictors", kinds: ["predictor"] },
			{ label: "Viz", kinds: ["viz"] },
			{ label: "UI", kinds: ["ui"] },
			// { label: "Pipelines", kinds: ["pipeline"] },
		];
*/
/*
export		const ROCK_PILE_GENERICS = [
			{ kind: "datasource" },
			{ kind: "filter" },
			{ kind: "augmentor" }, 
			{ kind: "transformer" },
			{ kind: "splitter" },
//			{ kind: "optimizer" },
			{ kind: "model" },
			{ kind: "algorithm" },
			{ kind: "automl" },
			{ kind: "predictor" },
			{ kind: "pipeline", name: "Training pipeline", purpose: "train" },
			{ kind: "pipeline", name: "Testing pipeline", purpose: "test" },
		];
*/
export		const ROCK_PILE_INDEX_STYLES = {
			// generic: { background: "#fff" },
			Datasets: { background: "rgb(255, 102, 128)" },
			Datasources: { background: "#f75" },
			ETL: { background: "#fdab19" },
			Models: { background: "#c6f" },
			Modelsets: { background: "rgb(153, 102, 255)" },
			Algorithms: { background: "rgb(15, 189, 140)" },
			Trainers: { background: "rgb(15, 189, 140)" },
			Testers: { background: "rgb(15, 189, 140)" },
			Predictors: { background: "rgb(15, 189, 140)" },
			Viz: { background: "#0be" },
			UI: { background: "#55f" },
			Stats: { background: "#509afc" },
			//Pipelines: { background: "#cf63cf" }
		};
export		const ROCK_STYLES = {
			service: { background: "#0af", border: "0.5px solid #038", color: "#fff" },
//			pipeline: { background: "#c78", border: "0.5px solid #af43af", color: "#fff" },
//			pipeline: { background: "#96f", border: "0.5px solid #74d", color: "#fff" },
//			pipeline: { background: "#809cc7", border: "0.5px solid #af43af", color: "#fff" },
			pipeline: { background: "#88c", border: "0.5px solid #66a", color: "#fff" },
//	 		datasource: { background: "#e64", border: "0.5px solid rgb(255, 51, 85)", color: "#fff" },
	 		datasource: { background: "#f75", border: "0.5px solid rgb(255, 51, 85)", color: "#fff" },
	 		modelset: { background: "rgb(153, 102, 255)", border: "0.5px solid rgb(119, 77, 203)", color: "#fff" },
	 		modelsource: { background: "#c6f", border: "0.5px solid rgb(119, 77, 203)", color: "#fff" },


	 		extractor: { background: "#fdab19", border: "0.5px solid rgb(207, 110, 23)", color: "#fff" },
	 		transformer: { background: "#fdab19", border: "0.5px solid rgb(207, 110, 23)", color: "#fff" },
	 		augmentor: { background: "#fdab19", border: "0.5px solid rgb(207, 110, 23)", color: "#fff" },
	 		filter: { background: "#fdab19", border: "0.5px solid rgb(207, 110, 23)", color: "#fff" },
	 		splitter: { background: "#fdab19", border: "0.5px solid rgb(207, 110, 23)", color: "#fff" },

	 		api: { background: "#aaa", border: "0.5px solid #888", color: "#fff" },
	 		ui: { background: "#55f", border: "0.5px solid #06c", color: "#fff" },
	 		stats: { background: "#509afc", border: "0.5px solid #06c", color: "#fff" },
	 		viz: { background: "#0be", border: "0.5px solid #06c", color: "#fff" },
	 		deployer: { background: "#aaa", border: "0.5px solid #888", color: "#fff" },
	 		placeholder: { background: "#fff", border: "0.5px dotted #888", color: "#fff" },
	 		//dashboard: { background: "#fff", border: "0.5px solid #888", color: "#333" },
	 		optimizer: { background: "rgb(15, 189, 140)", border: "0.5px solid rgb(11, 142, 105)", color: "#fff" },
	 		automl: { background: "rgb(15, 189, 140)", border: "0.5px solid rgb(11, 142, 105)", color: "#fff" },
	 		algorithm: { background: "rgb(15, 189, 140)", border: "0.5px solid rgb(11, 142, 105)", color: "#fff" },
	 		predictor: { background: "rgb(15, 189, 140)", border: "0.5px solid rgb(11, 142, 105)", color: "#fff" },
	 		tester: { background: "rgb(15, 189, 140)", border: "0.5px solid rgb(11, 142, 105)", color: "#fff" },
	 		trainer: { background: "rgb(15, 189, 140)", border: "0.5px solid rgb(11, 142, 105)", color: "#fff" },
	 		dataset: { background: "rgb(255, 102, 128)", border: "0.5px solid rgb(255, 51, 85)", color: "#fff" },
		};
export		const ROCK_NOTEBOOK_HEADER_STYLES = {
			train: { background: "#f70", borderColor: "#f50" },
			test: { background: "#0a7", borderColor: "#0c5" },
			production: { background: "#07f", borderColor: "#06c" },
			app: { background: "#0cf", borderColor: "#06c" },
		};


export default AMCConstants;





// WEBPACK FOOTER //
// ./src/AMCConstants.js